import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoEditorMixin from './KendoEditorMixin'

export default {
    name: 'kendo-editor',
    mixins: [ KendoEditorMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render(createElement) {
        const h = gh || createElement
        var tagName = this.tag || 'textarea'
        const defaultSlot = (this.v3 && this.$slots.default && (typeof this.$slots.default === 'function')) ? this.$slots.default() : this.$slots.default
        return h(tagName, defaultSlot)
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-editor-vue-wrapper/src/KendoEditor/index.js